import { render, staticRenderFns } from "./PVersionChecker.vue?vue&type=template&id=b1fb7382"
import script from "./PVersionChecker.vue?vue&type=script&lang=js"
export * from "./PVersionChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports